import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const TeleporterContext = React.createContext({
    content: null,
    setContent: () => null,
});
/**
 * Render a react component somewhere else.
 */
export const Teleporter = ({ children }) => {
    const [content, setContent] = React.useState(null);
    return (_jsx(TeleporterContext.Provider, { value: { content, setContent }, children: children }));
};
export const TeleporterDestination = () => {
    const { content } = React.useContext(TeleporterContext);
    return content;
};
export const Teleport = ({ children }) => {
    const { setContent } = React.useContext(TeleporterContext);
    React.useEffect(() => {
        setContent(children);
        return () => {
            setContent(null);
        };
    }, [children, setContent]);
    return null;
};
